interface TitleProps {
  title: string
  size: string | number
  position: 'esquerda' | 'centralizado' | 'direita'
  titleHeadingTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  color: string
}

const POSITION_MAP = {
  esquerda: 'left',
  centralizado: 'center',
  direita: 'right',
} as const

const JUSTIFY_MAP = {
  esquerda: 'flex-start',
  centralizado: 'center',
  direita: 'flex-end',
} as const

const parseFontSize = (size: string | number) => {
  if (typeof size === 'number' && Number.isFinite(size)) {
    return `${size}px`
  }

  if (typeof size !== 'string') {
    return undefined
  }

  const normalizedSize = size.trim().toLowerCase()
  const sizeMatch = normalizedSize.match(/^(\d+(?:\.\d+)?)(?:px)?$/)

  return sizeMatch ? `${sizeMatch[1]}px` : undefined
}

export function Title({
  title,
  size,
  position = 'esquerda',
  titleHeadingTag = 'h2',
  color = '#101010',
}: TitleProps) {
  const textPosition = POSITION_MAP[position]
  const justifyPosition = JUSTIFY_MAP[position]
  const HeadingTag = titleHeadingTag
  const fontSize = parseFontSize(size)

  if (!title) {
    return null
  }

  return (
    <div
      className="flex gap-4 my-12 max-w-[1550px] items-center mx-auto"
      style={{ justifyContent: justifyPosition }}
    >
      <HeadingTag
        className="font-inter font-bold max-w-[522px]"
        style={{
          color,
          textAlign: textPosition,
          fontSize,
        }}
      >
        {title}
      </HeadingTag>
    </div>
  )
}
